// ============================================================================
// mediaPlayerContext — API ЕДИНОГО проигрывателя для его расширений (footer):
// перемотка (seek) и текущее время. Значение подставляет MediaPlayer
// (MediaPlayerApiContext.Provider), потребитель — панель расшифровки
// (переход по слову). Контекст вместо проп-цепочки: расширение не знает
// о внутренностях плеера. SSoT «играет один» не затрагивается — перемотка
// тем же seek, что у волны/полосы, воспроизведение не запускает.
// ============================================================================

import { createContext, useContext } from 'react';

/** API плеера: перемотка и текущее время (секунды). */
export interface MediaPlayerApi {
  /** Перейти к позиции (секунды). */
  seek: (seconds: number) => void;
  /** Текущая позиция, секунды. */
  current: number;
  /** Длительность, секунды (0 — ещё не известна). */
  duration: number;
  /** Идёт воспроизведение. */
  playing: boolean;
}

export const MediaPlayerApiContext = createContext<MediaPlayerApi | null>(null);

/** API текущего плеера; вне проигрывателя — null (кликов по словам нет). */
export function useMediaPlayerApi(): MediaPlayerApi | null {
  return useContext(MediaPlayerApiContext);
}
